<div style="position: relative">
    <div #pointer class="pointer" style="left: 0px">
        <mat-icon
            class="pointer-icon"
            [class]="alarmTextClass"
            svgIcon="value-pointer"
        >
        </mat-icon>
    </div>

    <div #valueContainer class="value-container" [class]="alarmBorderClass">
        <span
            class="value-icons"
            [ngClass]="{
                flip: valueChangeDirection == -1,
                hide: valueChangeDirection == 0
            }"
        >
            <mat-icon
                class="direction-arrow"
                style="opacity: 0.3"
                [class]="alarmTextClass"
                svgIcon="value-pointer"
            >
            </mat-icon>
            <mat-icon
                class="direction-arrow"
                style="opacity: 0.7"
                [class]="alarmTextClass"
                svgIcon="value-pointer"
            >
            </mat-icon>
            <mat-icon
                class="direction-arrow"
                style="opacity: 1"
                [class]="alarmTextClass"
                svgIcon="value-pointer"
            >
            </mat-icon>
        </span>
        <span #valueText class="value-label" [class]="alarmTextClass"></span>
    </div>
</div>

<div #rangeContainer class="range-container">
    <div
        #veryLow
        class="bar"
        [class]="barColorMap.get(States.LOW_LOW)"
        [ngClass]="{ active: status == States.LOW_LOW }"
    ></div>

    <div
        #low
        class="bar"
        [class]="barColorMap.get(States.LOW)"
        [ngClass]="{
            active: status == States.LOW,
            'divider-left': shouldShowLeftDivider()
        }"
    ></div>

    <div
        #lowToNormalGap
        class="bar bar-gap"
        [ngClass]="{ active: status == States.NORMAL}"
    ></div>

    <div
        #normal
        class="bar bar-normal"
        [ngClass]="{ active: status == States.NORMAL }"
    ></div>

    <div
        #normalToHighGap
        class="bar bar-gap"
        [ngClass]="{ active: status == States.NORMAL}"
    ></div>

    <div
        #high
        class="bar"
        [class]="barColorMap.get(States.HIGH)"
        [ngClass]="{
            active: status == States.HIGH,
            'divider-right': shouldShowRightDivider()
        }"
    ></div>

    <div
        #veryHigh
        class="bar"
        [class]="barColorMap.get(States.HIGH_HIGH)"
        [ngClass]="{ active: status == States.HIGH_HIGH }"
    ></div>
</div>
